module.exports = "/deep/\n.loading-row {\n  display: flex;\n  align-items: center;\n  height: 80vh;\n  font-size: 1.75em; }\n  /deep/\n.loading-row .loading-text {\n    letter-spacing: 4px;\n    font-family: monospace; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/messages/edit.component.scss
// module id = 571
// module chunks = 1